import { LAYOUT } from '@admin/router/constant'

// tms
const FtspRouter = {
  path: '/ftsp',
  name: '',
  component: LAYOUT,
  children: [
    {
      path: '/ftsp/basicInfo/product',
      name: 'FTSPBasicInfoProduct',
      component: () => import('@admin/views/ftsp/basicInfo/product/index.vue'),
      meta: {
        title: '商品列表',
      },
    },
    {
      path: '/ftsp/customsDeclaration/orderList',
      name: 'FTSPCustomsDeclarationOrderList',
      component: () => import('@admin/views/ftsp/customsDeclaration/orderList/index.vue'),
      meta: {
        title: '订单列表',
      },
    },
    {
      path: '/ftsp/customsDeclaration/orderList/details',
      name: 'FTSPCustomsDeclarationOrderDetails',
      component: () => import('@admin/views/ftsp/customsDeclaration/orderList/details.vue'),
      meta: {
        title: '订单详情',
      },
    },
  ],
}

export default FtspRouter
